import React from "react";
import styled from "styled-components";
import { useSelector } from "react-redux";
import { Line, Chart } from "react-chartjs-2";
import { useTheme } from "theme";
import { isMobile, userMaskAllValuesSelector } from "@kubera/common";

const isMobileDevice = isMobile();

const Container = styled.div`
  position: relative;
  margin-left: -5px;
  margin-right: -5px;
  transform: translate3d(0, 0, 0);
`;
const ChartBuffer = styled.div`
  width: 100%;
  min-height: 15px;
  background: ${props => props.theme[props.bgThemeColor]};
`;

class LineChartComponent extends React.Component {
  constructor(props) {
    super(props);

    this.chartRef = React.createRef();
    this.containerRef = React.createRef();
    this.chartPadding = React.createRef();
    this.isTouching = false;
  }

  datasetKeyProvider() {
    return window.btoa(Math.random()).substring(0, 12);
  }

  getChartPadding() {
    // This is done to ensure the hover points near the
    // container boundaries don't get cut off
    if (this.chartPadding.current) {
      return this.chartPadding.current;
    }
    var padding = this.props.chartPadding;
    for (const key in padding) {
      if (key === "left" || key === "right") {
        padding[key] = padding[key] + 5;
      }
    }
    this.chartPadding.current = padding;
    return padding;
  }

  chartDataHasNegativeValue(chartData) {
    for (const dataset of chartData.datasets) {
      for (const data of dataset.data) {
        if (data < 0) {
          return true;
        }
      }
    }
    return false;
  }

  getOptions(id, chartData, scaleType = undefined) {
    return {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0
      },
      layout: {
        padding: this.getChartPadding()
      },
      title: {
        display: false
      },
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            display: false,
            type: scaleType
          }
        ],
        yAxes: [
          {
            gridLines: {
              display: false,
              drawTicks: false,
              lineWidth: 0,
              zeroLineWidth: 2,
              zeroLineColor: this.props.theme.lineChartZeroLineColor,
              zeroLineBorderDash: [5, 5]
            },
            ticks: {
              display: false
            }
          }
        ]
      }
    };
  }

  getDataWithOptions(data) {
    const defaultOptions = {
      borderColor: "rgba(128, 0, 255, 0.1)",
      backgroundColor: "rgba(128, 0, 255, 0.03)",
      fill: "start",
      borderWidth: 1,
      pointRadius: 4,
      pointBorderColor: "rgba(0, 0, 0, 0)",
      pointBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBackgroundColor: "rgba(0, 0, 0, 0)",
      pointHoverBorderColor: "rgba(0, 0, 0, 0)"
    };
    const options = {};

    data.datasets = data.datasets.map(dataSet => {
      const temp = { ...dataSet, ...defaultOptions, ...options };
      return temp;
    });
    return data;
  }

  render() {
    const {
      className,
      chartHeight = 120,
      onHoverOverSection,
      onClickOverSection,
      themeMode,
      showBuffer = false,
      id = 1,
      scaleType,
      ...other
    } = this.props;

    const data = {
      labels: ["January", "February", "March", "April"],
      datasets: [
        {
          data: [10, 50, 25, 60],
          borderColor: "rgba(128, 0, 255, 0.1)",
          backgroundColor: "rgba(128, 0, 255, 0.02)",
          fill: "start",
          borderWidth: 1,
          pointRadius: 4
        }
      ]
    };

    const chartData = this.getDataWithOptions(data);

    return (
      <>
        <Container ref={this.containerRef} className={`chartjs-container ${className} ${themeMode}`} {...other}>
          <Line
            ref={this.chartRef}
            data={chartData}
            options={this.getOptions(id, chartData, scaleType)}
            height={chartHeight}
            datasetKeyProvider={this.datasetKeyProvider}
          />
        </Container>
        <ChartBuffer className="chartjs-buffer" bgThemeColor="chartSkeletonBufferColor" />
      </>
    );
  }
}

const LineChartSkeletonLoader = props => {
  const theme = useTheme();

  return (
    <LineChartComponent
      {...props}
      theme={theme}
      themeMode={theme.mode}
      bgcolor={props.chartBgColor || theme.chartBgColor}
      showZeroLine={false}
    />
  );
};

export default LineChartSkeletonLoader;
